import { Injectable } from '@angular/core';
import { Config, SafeArea } from '@capacitor-community/safe-area';

@Injectable({
  providedIn: 'root'
})
export class SafeAreaWrapper {

  enable(config: Config): Promise<void> {
    const enablePromise = SafeArea.enable({
      config: config
    });

    return enablePromise;
  }
}